/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Backdrop, Box, Button, CircularProgress, Divider, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { fileApiRoute } from "../../../services/networkService";
import DriverService from "../../../services/driverService";
import { formatPrice } from "../../../utils";


const ViewDriverModal = ({ open,
    handleClose,
    driverId }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [driver, setDriver] = useState({});
    const [isModalLoading, setIsModalLoading] = useState(true);

    const fetchDriver = async () => {
        try {
            const data = await DriverService.fetchOne(driverId);
            setDriver(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching driver:', error);
        }
    };

    useEffect(() => {
        setIsModalLoading(true);
        if (open) {
            fetchDriver();
        }
    }, [open]);


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '90%' : '60%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isMobile ? 2 : 4,
                        height: '80vh',
                        overflowY: 'scroll'
                    }}
                >
                    {isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>

                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('driverInfo')}
                                </Typography>
                                <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: isMobile ? 'column' : 'row',
                                    width: '100%'
                                }}>

                                {/* col 1 */}
                                <Box width={isMobile ? '100$' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('name')}: <span style={{ fontWeight: 'bold' }}>{driver.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('city')}: <span style={{ fontWeight: 'bold' }}>{driver.city.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('branch')}: <span style={{ fontWeight: 'bold' }}>{driver.branch.name}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('supervisor')}: <span style={{ fontWeight: 'bold' }}>{driver.supervisor.name}</span>
                                    </Typography>

                                    {/* status */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                        <Typography variant="body1" sx={{ mt: 2 }}>
                                            {t('status')}:
                                        </Typography>
                                        <Box
                                            sx={{
                                                justifyContent: 'center',
                                                display: 'flex',
                                                py: 0.2,
                                                mt: 2,
                                                mx: 0.3
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    fontWeight: 'bold',
                                                    color: driver.status === 'active' ? theme.palette.green.box : theme.palette.red.box,
                                                }}
                                            >
                                                {t(driver.status)}
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('posts')}: <span style={{ fontWeight: 'bold' }}>{driver.posts}</span>
                                    </Typography>
                                </Box>

                                {/* col 2 */}
                                <Box width={isMobile ? '100$' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('phone')}: <span style={{ fontWeight: 'bold' }}>{driver.phone}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('phoneTwo')}: <span style={{ fontWeight: 'bold' }}>{driver.phoneTwo}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('transportationPriceSmall')}: <span style={{ fontWeight: 'bold' }}>{driver.transportationPrice}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('wallet')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(driver.wallet)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('remainAmount')}: <span style={{ fontWeight: 'bold' }}>{formatPrice(driver.remainAmount)}</span>
                                    </Typography>

                                </Box>

                            </Box>


                            {/* note */}
                            <Typography variant="body1"
                                sx={{
                                    mt: 1.5,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('note')}: <span style={{ fontWeight: 'bold' }}>{driver.note}</span>
                            </Typography>


                            <Divider sx={{ mt: 2, mb: 1 }} />
                            <Box
                                sx={{
                                    display: 'flex',
                                    overflowX: isMobile ? 'scroll' : 'hidden'
                                }}>
                                <Box width={isMobile ? '130px' : '20%'}>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                        {t('prices')}:
                                    </Typography>
                                </Box>

                                <Box width={isMobile ? '130px' : '40%'}>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                        {t('street')}:
                                    </Typography>
                                </Box>

                                <Box width={isMobile ? '150px' : '40%'}>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                        {t('transportationPrice')}:
                                    </Typography>
                                </Box>

                            </Box>


                            {
                                driver?.streetDrivers.map((street, index) => (
                                    <Box
                                        sx={{
                                            display: 'flex'
                                        }}>
                                        <Box width={isMobile ? '130px' : '20%'}>
                                            <Typography variant="body1" sx={{ mt: 1 }}>
                                                {index + 1}
                                            </Typography>
                                        </Box>

                                        <Box width={isMobile ? '130px' : '40%'}>
                                            <Typography variant="body1" sx={{ mt: 1 }}>
                                                {street.street.name}
                                            </Typography>
                                        </Box>

                                        <Box width={isMobile ? '150px' : '40%'}>
                                            <Typography variant="body1" sx={{ mt: 1 }}>
                                                {formatPrice(street.transportationPrice)}
                                            </Typography>
                                        </Box>

                                    </Box>
                                ))
                            }


                            <Divider sx={{ mb: 2, mt: 1 }} />

                            {/* images */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    mt: 2
                                }}>
                                <Box sx={{ width: '48%' }}>
                                    <Typography variant="body1">
                                        {t('image')}:
                                    </Typography>
                                    <Avatar
                                        variant="rounded"
                                        src={`${fileApiRoute}/${driver.image}`}
                                        sx={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '20vh',
                                            mt: 1
                                        }}
                                    />
                                </Box>

                                <Box sx={{ width: '48%' }}>
                                    <Typography variant="body1">
                                        {t('IDimage')}:
                                    </Typography>
                                    <Avatar
                                        variant="rounded"
                                        src={`${fileApiRoute}/${driver.IDImage}`}
                                        sx={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '20vh',
                                            mt: 1
                                        }}
                                    />
                                </Box>

                            </Box>

                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: 2
                            }}>
                                {/* close */}
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                    onClick={handleClose}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('close')}</p>
                                        <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                </Button>

                                <Box width={20}></Box>

                            </Box>
                        </Box>
                    }
                </Box>
            </Fade>
        </Modal>
    );
}

export default ViewDriverModal;
